var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconRedo = function SvgIconRedo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.494 9.364H7.768q-1.035 0-1.735.753a2.56 2.56 0 0 0-.701 1.81q0 1.058.7 1.816a2.27 2.27 0 0 0 1.736.757h5.522q.225 0 .383.159a.52.52 0 0 1 .159.383q0 .224-.159.383a.52.52 0 0 1-.383.158H7.768q-1.475 0-2.497-1.078a3.62 3.62 0 0 1-1.023-2.577q0-1.5 1.023-2.573Q6.293 8.281 7.768 8.28h5.726L11.78 6.567a.55.55 0 0 1-.178-.383.53.53 0 0 1 .178-.39q.181-.182.386-.182.207 0 .388.181l2.564 2.564a.64.64 0 0 1 .192.465.66.66 0 0 1-.192.465l-2.564 2.564a.5.5 0 0 1-.373.167.56.56 0 0 1-.38-.188.54.54 0 0 1-.182-.387q0-.206.181-.387z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconRedo);
export { ForwardRef as ReactComponent };